import React, {
    useEffect, useState, useCallback,
} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import _ from 'lodash';
import format from 'date-fns/format';
import PropTypes from 'prop-types';
import {
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
    FormHelperText,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import { useIntl } from 'react-intl';
import Divider from '@material-ui/core/Divider';
import { whiteColor } from '../../assets/jss/global';
import WrapperContainer from '../../components/Container/WrapperContainer';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import CustomTypography from '../../components/Typography/CustomTypography';
import CleanableInput from '../../components/Input/CleanableInput';
import SelectorInput from '../../components/Input/SelectorInput';
import Validation from '../../common/Validation';
import { TooltipIcon } from '../../components/Icons/Icon';
import Button from '../../components/Button/CustomButton';
import SuccessDialog from '../../components/Dialog/SuccessDialog';

import Popper from '../../components/Popper/Popper';
import registrationViewerStyle from '../../assets/jss/pages/registrationViewerStyle';
import { locationOption, Role } from '../../common/Constants';
import SnackBar from '../../components/Snackbar/Snackbar';
import Loader from '../../components/Loader/Loader';

const useStyles = makeStyles(registrationViewerStyle);

export default function RegistrationViewer(props) {
    const {
        registrations, createViewer, successCreate, errors, options, isLoading, clearData,
        fetchJobs, jobs, logOut, isAuthorized, customColor, getCustomText, customText, clearCustomText,
        occupations, getOccupations, clearOccupations, locale, eventInfo,
    } = props;
    const classes = useStyles(props);
    const intl = useIntl();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));

    const [params, setParams] = useState({
        checkRule: false,
        seminar: '2',
        exhibitions: '1',
        purpose_another: '0',
        age_range: '0',
        job: '',
        location: '0',
        purpose: '0',
        occupation: '0',
        employee_number: '0',
        viewer_live_stream: '1',
    });
    const history = useHistory();
    const { shortName } = useParams();

    const [validateResults, setValidateResults] = useState({});
    const [openPopper, setOpenPopper] = useState(false);
    const [popperTarget, setPopperTarget] = useState(null);
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [errorCreate, setErrorCreate] = useState({ isOpen: false, type: 'error', message: '' });
    const [listOptionCompanyFromApi, setListOptionCompanyFromApi] = useState({});
    const [listPurposeOptionFromApi, setListPurposeOptionFromApi] = useState({});
    const [listOptionAgeRangeFromApi, setOptionAgeRangeFromApi] = useState({});
    const [listPurposeAnotherOptionFromApi, setListPurposeAnotherOptionFromApi] = useState({});
    const [listOptionEmployeeNumberFromApi, setOptionEmployeeNumberFromApi] = useState({});
    const [listOptionOccupationFromApi, setOptionOccupationFromApi] = useState({});
    const [jobState, setJobState] = useState({});
    const [occupationState, setOccupationState] = useState({});
    const [hasAdditionalPurpose, setHasAdditionalPurpose] = useState(false);

    const seminarValue = { yes: '2', no: '0' };
    const exhibitionsValue = { yes: '1', no: '0' };
    const liveStreamValue = { yes: '1', no: '0' };

    useEffect(() => {
        fetchJobs({ shortName, role: Role.viewer, language: locale });
        getOccupations({ shortName, role: 0, language: locale });
        getCustomText({
            eventShortName: shortName,
            site: 0,
            text_type: 6,
            language: locale,
        });
    }, [locale]);

    useEffect(() => () => {
        clearData();
        clearCustomText();
        clearOccupations();
    }, []);

    // Set list Option Company
    useEffect(() => {
        if (options && options.company_option) {
            let temp = {};
            options.company_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListOptionCompanyFromApi({ ...listOptionCompanyFromApi, ...temp });
        }
    }, [options]);

    // Set list Option purpose
    useEffect(() => {
        if (options && options.purpose_option) {
            let temp = {};
            options.purpose_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListPurposeOptionFromApi({ ...listPurposeOptionFromApi, ...temp });
        }
    }, [options]);

    // Set list seminar_option(AnotherOption)
    useEffect(() => {
        if (options && options.seminar_option) {
            let temp = {};
            options.seminar_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListPurposeAnotherOptionFromApi({ ...listPurposeAnotherOptionFromApi, ...temp });
        }
    }, [options]);

    // Set list Option age
    useEffect(() => {
        if (options && options.age_range_option) {
            let temp = {};
            options.age_range_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionAgeRangeFromApi({ ...listOptionAgeRangeFromApi, ...temp });
        }
    }, [options]);

    // Set list employee_number
    useEffect(() => {
        if (options && options.employee_number_option) {
            let temp = {};
            options.employee_number_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionEmployeeNumberFromApi({ ...listOptionEmployeeNumberFromApi, ...temp });
        }
    }, [options]);

    // Set list Occupation
    useEffect(() => {
        if (options && options.occupation_option) {
            let temp = {};
            options.occupation_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionOccupationFromApi({ ...listOptionOccupationFromApi, ...temp });
        }
    }, [options]);

    useEffect(() => {
        if (!_.isEmpty(jobs)) {
            setJobState(_.reduce(jobs, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [jobs]);

    useEffect(() => {
        if (!_.isEmpty(occupations)) {
            setOccupationState(_.reduce(occupations, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [occupations]);

    useEffect(() => {
        if (successCreate) {
            setIsOpenDialog(true);
        }
    }, [successCreate]);

    useEffect(() => {
        if (errors && errors.errors && errors.errors.code === 'BAD_REQUEST') {
            setValidateResults({ ...errors.errors });
            setErrorCreate({
                ...errorCreate,
                isOpen: true,
                type: 'error',
                message: errors.errors.message
                    ? errors.errors.message.message : intl.formatMessage({ id: 'common.errorInfo' }),
            });
        } else {
            setErrorCreate({
                ...errorCreate, isOpen: false,
            });
        }
    }, [errors]);

    // Set display その他
    useEffect(() => {
        if (Number(params.purpose) === Object.keys(listPurposeOptionFromApi).length - 1) {
            setHasAdditionalPurpose(true);
        } else {
            setHasAdditionalPurpose(false);
        }
    }, [params.purpose]);

    const createDataToCallApi = () => {
        const numberSeminar = registrations?.has_seminar ? Number(params.seminar) : 0;
        const numberExhibition = registrations?.has_exhibition ? Number(params.exhibitions) : 0;
        const numberLiveStream = registrations?.has_live_stream ? params.viewer_live_stream : '0';

        const dataToCallApi = {
            viewer_type: numberSeminar + numberExhibition,
            email: checkUndefined(params.email),
            event: registrations.id,
            first_name: checkUndefined(params.firstName),
            last_name: checkUndefined(params.lastName),
            work_place: checkUndefined(params.workPlace),
            department: checkUndefined(params.department),
            location: checkUndefined(params.location),
            position: checkUndefined(params.position),
            zip_code: checkUndefined(params.zipCode),
            address: checkUndefined(params.address),
            phone_number: checkUndefined(params.phoneNumber),
            fax_number: checkUndefined(params.faxNumber),
            job: checkUndefined(params.job),
            purpose: checkUndefined(params.purpose),
            purpose_another: (numberSeminar === 2 && !registrations.free_seminar) ? checkUndefined(params.purpose_another) : '0',
            age_range: checkUndefined(params.age_range),
            employee_number: checkUndefined(params.employee_number),
            occupation_name: checkUndefined(params.occupation_name),
            additional_purpose: hasAdditionalPurpose ? checkUndefined(params.additional_purpose) : '',
            viewer_live_stream: numberLiveStream,
            language: locale,
        };
        return dataToCallApi;
    };

    const checkUndefined = (values) => (!_.isUndefined(values) ? values.trim() : '');

    const formatDate = (values) => (format(new Date(values), 'yyyy/MM/dd'));

    const handleSubmit = () => {
        if (validate()) {
            const dataToCallApi = createDataToCallApi();
            createViewer(dataToCallApi);
        }
    };
    const handleCloseDialog = () => {
        clearData();
        setIsOpenDialog(false);
        if (isAuthorized) {
            logOut();
        }
        history.push(`/${shortName}/home`);
    };

    const validate = () => {
        const numberSeminarCheck = registrations?.has_seminar ? Number(params.seminar) : 0;
        const numberExhibitionCheck = registrations?.has_exhibition ? Number(params.exhibitions) : 0;
        const numberLiveStreamCheck = registrations?.has_live_stream ? Number(params.viewer_live_stream) : 0;
        const {
            email, firstName, lastName, workPlace, zipCode, address,
            purpose, checkRule, department, position, purpose_another,
            phoneNumber, faxNumber, emailConfirm, additional_purpose, viewer_live_stream,
        } = params;
        const optionCheck = numberSeminarCheck + numberExhibitionCheck + numberLiveStreamCheck;
        const validateRules = {
            first_name: [
                () => Validation.isNotEmpty(firstName),
                () => Validation.validateMaxLength(firstName, 255),
            ],
            last_name: [
                () => Validation.isNotEmpty(lastName),
                () => Validation.validateMaxLength(lastName, 255),
            ],
            email: [
                () => Validation.isNotEmpty(email),
                () => Validation.validateEmail(email),
                () => Validation.validateMaxLength(email, 255),
            ],
            emailConfirm: [
                () => Validation.validateSame(email, emailConfirm),
            ],
            work_place: [() => Validation.isNotEmpty(workPlace),
                () => Validation.validateMaxLength(workPlace, 255)],
            zip_code: [() => Validation.isNotEmpty(zipCode),
                () => Validation.validateMaxLength(zipCode, 255)],
            address: [() => Validation.isNotEmpty(address),
                () => Validation.validateMaxLength(address, 1000)],
            department: [() => Validation.validateMaxLength(department, 255)],
            position: [() => Validation.validateMaxLength(position, 255)],
            phone_number: [
                () => Validation.validateMaxLength(phoneNumber, 255),
                () => Validation.validatePhoneNumber(phoneNumber && phoneNumber.trim()),
            ],
            fax_number: [() => Validation.validateMaxLength(faxNumber, 255)],
            purpose: [() => Validation.isNotEmpty(listPurposeOptionFromApi[purpose])],
            // purpose_another: [Number(params.seminar) === 2 ? () => Validation.isNotEmpty(listPurposeAnotherOptionFromApi[purpose_another]) : () => { }],
            purpose_another: [(numberSeminarCheck === 2 && !registrations.free_seminar) ? () => Validation.isNotEmpty(listPurposeAnotherOptionFromApi[purpose_another]) : () => { }],
            checkRule: [() => Validation.isCheck(checkRule)],
            viewer_type: [() => Validation.isPositiveNumbers(optionCheck)],
            additional_purpose:
                hasAdditionalPurpose
                    ? [() => Validation.isNotEmpty(additional_purpose),
                        () => Validation.validateMaxLength(additional_purpose, 255)]
                    : [() => { }],
            viewer_live_stream: [() => Validation.isPositiveNumbers(optionCheck)],
        };
        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const handleSetParams = useCallback((field, valueChange) => {
        setParams((prevParams) => ({ ...prevParams, [field]: valueChange }));
    }, []);

    const handleOpenPopper = (event) => {
        setOpenPopper(true);
        setPopperTarget(event.currentTarget);
    };

    const handleInputPostalCode = (valueInput) => {
        handleSetParams('zipCode', valueInput);
        valueInput = valueInput.trim();
        const code = valueInput.substr(0, 3);
        if (code && code.length === 3 && valueInput.length === 7) {
            const pathPostal = process.env.REACT_APP_POSTAL_URL || '';
            fetch(`${pathPostal}/postal/${code}.json`)
                .then((res) => res.json())
                .then((data) => {
                    const d = data.find((it) => it[valueInput]);
                    handleSetParams('address', d[valueInput][0]);
                }).catch(() => {
                    // TODO
                });
        } else {
            handleSetParams('address', '');
        }
    };

    return (
        <>
            <WrapperContainer className={classes.wrapper}>
                <GridItem xs={12} md={12} className={classes.background}>
                    <GridContainer>
                        <GridItem xs={12} md={10} className={`${classes.paddingTop5vh}  ${classes.marginAuto}`}>
                            <GridContainer>
                                <GridItem>
                                    <CustomTypography bold variant="h4" color="info" align="center" customColor={customColor.event_name_text_color}>
                                        {registrations.name}
                                    </CustomTypography>
                                    <Divider className={classes.divider} />
                                </GridItem>
                            </GridContainer>
                            <GridContainer className={classes.eventInfo}>
                                <GridItem xs={12} sm={5} md={4}>
                                    <CustomTypography variant="subtitle1" bold customColor={customColor.contents_text_color}>
                                        {registrations?.settings_texts_event_viewer?.field_name?.holding_period || intl.formatMessage({ id: 'event.heldDate' })}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={7} md={8}>
                                    <CustomTypography variant="subtitle1" color="info" bold customColor={customColor.event_name_text_color}>
                                        {registrations.sdate && formatDate(registrations.sdate)}
                                        {' '}
                                        ~
                                        {' '}
                                        {registrations.edate && formatDate(registrations.edate)}
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>

                            <GridContainer className={classes.eventInfo}>
                                <GridItem xs={12} sm={5} md={4}>
                                    <CustomTypography variant="subtitle1" bold customColor={customColor?.contents_text_color}>
                                        {registrations?.settings_texts_event_viewer?.field_name?.open_time || intl.formatMessage({ id: 'event.heldTime' })}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={7} md={8}>
                                    <CustomTypography variant="subtitle1" color="info" bold customColor={customColor?.event_name_text_color}>
                                        {registrations.open_time}
                                        {' '}
                                        ~
                                        {' '}
                                        {registrations.close_time}
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>

                            <GridContainer className={classes.margin2vh}>
                                <GridItem xs={12} sm={5} md={4}>
                                    <CustomTypography variant="subtitle1" bold customColor={customColor?.contents_text_color}>
                                        {registrations?.settings_texts_event_viewer?.field_name?.venue || intl.formatMessage({ id: 'event.heldPlace' })}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={7} md={8}>
                                    <CustomTypography variant="subtitle1" customColor={customColor?.contents_text_color}>
                                        {registrations.address}
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>

                            {registrations.has_exhibition && !registrations.free_exhibition && (
                                <GridContainer className={classes.eventInfo}>
                                    <GridItem xs={12} sm={5} md={4}>
                                        <CustomTypography variant="subtitle1" bold customColor={customColor?.contents_text_color}>
                                            {customText?.field_name?.exhibition_application || intl.formatMessage({ id: 'registerViewer.exhibitionAdmissionApplication' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={8}>
                                        <RadioGroup
                                            aria-label="exhibitions"
                                            name="exhibitions"
                                            value={params.exhibitions}
                                            onChange={(e) => setParams({
                                                ...params,
                                                exhibitions: e.target.value,
                                            })}
                                            row
                                        >
                                            <FormControlLabel
                                                value={exhibitionsValue.yes}
                                                control={<Radio color="primary" />}
                                                label={<CustomTypography variant="subtitle1" customColor="#4b4b4b">{intl.formatMessage({ id: 'common.yes' })}</CustomTypography>}
                                                className={classes.paddingRight3vW}
                                            />
                                            <FormControlLabel
                                                value={exhibitionsValue.no}
                                                control={<Radio color="primary" />}
                                                label={<CustomTypography variant="subtitle1" customColor="#4b4b4b">{intl.formatMessage({ id: 'common.no' })}</CustomTypography>}
                                                className={classes.colorIconRadio}
                                            />
                                        </RadioGroup>
                                    </GridItem>
                                </GridContainer>
                            )}

                            {registrations.has_seminar && !registrations.free_seminar && (
                                <GridContainer className={classes.eventInfo}>
                                    <GridItem xs={12} sm={5} md={4}>
                                        <CustomTypography variant="subtitle1" bold customColor={customColor?.contents_text_color}>
                                            {customText?.field_name?.seminar_application || intl.formatMessage({ id: 'registerViewer.applicationSeminar' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={8} className={classes.textCenter}>
                                        <RadioGroup
                                            aria-label="seminar"
                                            name="seminar"
                                            value={params.seminar}
                                            onChange={(e) => setParams({
                                                ...params,
                                                seminar: e.target.value,
                                            })}
                                            row
                                        >
                                            <FormControlLabel
                                                value={seminarValue.yes}
                                                control={<Radio color="primary" />}
                                                label={
                                                    <CustomTypography variant="subtitle1" customColor="#4b4b4b">{intl.formatMessage({ id: 'common.yes' })}</CustomTypography>
                                                }
                                                className={classes.paddingRight3vW}
                                            />
                                            <FormControlLabel
                                                value={seminarValue.no}
                                                control={<Radio color="primary" />}
                                                label={
                                                    <CustomTypography variant="subtitle1" customColor="#4b4b4b">{intl.formatMessage({ id: 'common.no' })}</CustomTypography>
                                                }
                                                className={classes.colorIconRadio}
                                            />
                                        </RadioGroup>
                                    </GridItem>
                                </GridContainer>
                            )}
                            {registrations.has_live_stream && !registrations.free_live_stream && (
                                <GridContainer className={classes.eventInfo}>
                                    <GridItem xs={12} sm={5} md={4}>
                                        <CustomTypography variant="subtitle1" bold customColor={customColor?.contents_text_color}>
                                            {customText?.field_name?.livestream_application || intl.formatMessage({ id: 'registerViewer.applicationLivestream' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={8} className={classes.textCenter}>
                                        <RadioGroup
                                            aria-label="viewer_live_stream"
                                            name="viewer_live_stream"
                                            value={params.viewer_live_stream}
                                            onChange={(e) => setParams({
                                                ...params,
                                                viewer_live_stream: e.target.value,
                                            })}
                                            row
                                        >
                                            <FormControlLabel
                                                value={liveStreamValue.yes}
                                                control={<Radio color="primary" />}
                                                label={<CustomTypography variant="subtitle1" customColor="#4b4b4b">{intl.formatMessage({ id: 'common.yes' })}</CustomTypography>}
                                                className={classes.paddingRight3vW}
                                            />
                                            <FormControlLabel
                                                value={liveStreamValue.no}
                                                control={<Radio color="primary" />}
                                                label={<CustomTypography variant="subtitle1" customColor="#4b4b4b">{intl.formatMessage({ id: 'common.no' })}</CustomTypography>}
                                                className={classes.colorIconRadio}
                                            />
                                        </RadioGroup>
                                    </GridItem>
                                </GridContainer>
                            )}
                            <GridContainer>
                                <GridItem>
                                    <FormHelperText error className="MuiFormHelperText-contained">
                                        {validateResults.viewer_type || validateResults.viewer_live_stream
                                            ? intl.formatMessage({ id: validateResults.viewer_type.message }) : ''}
                                    </FormHelperText>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.formInputInformation}>
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} md={12}>
                            <CustomTypography
                                variant="h4"
                                color="info"
                                bold
                                align="center"
                                customColor={customColor?.event_name_text_color}
                            >
                                {intl.formatMessage({ id: 'registerViewer.register' })}
                                <IconButton onClick={handleOpenPopper} className={locale === 'en' ? classes.tooltipStyleEN : classes.tooltipStyle}>
                                    <TooltipIcon color="#E17A3F" />
                                </IconButton>
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.work_place || intl.formatMessage({ id: 'workplace' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridItem xs={12} md={12}>
                                <CleanableInput
                                    classes={{ root: classes.colorTextInput }}
                                    onChange={(valueInput) => handleSetParams('workPlace', valueInput)}
                                    error={!!validateResults.work_place}
                                    helperText={validateResults.work_place
                                        ? intl.formatMessage(
                                            { id: validateResults.work_place.message },
                                            { maxLength: 255 },
                                        ) : ''}
                                />
                                <CustomTypography customColor={customColor?.contents_text_color}>
                                    {intl.formatMessage({ id: 'registerViewer.workPlace' }, {
                                        workPlace: customText?.field_name?.work_place || intl.formatMessage({ id: 'workplace.company' }),
                                    })}
                                </CustomTypography>
                            </GridItem>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.department || intl.formatMessage({ id: 'department' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        onChange={(valueInput) => handleSetParams('department', valueInput)}
                                        error={!!validateResults.department}
                                        helperText={validateResults.department
                                            ? intl.formatMessage(
                                                { id: validateResults.department.message },
                                                { maxLength: 255 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.position || intl.formatMessage({ id: 'position' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        onChange={(valueInput) => handleSetParams('position', valueInput)}
                                        error={!!validateResults.position}
                                        helperText={validateResults.position
                                            ? intl.formatMessage(
                                                { id: validateResults.position.message },
                                                { maxLength: 255 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} md={3}>
                            <CustomTypography required className={classes.paddingTop15} bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.name || intl.formatMessage({ id: 'fullName' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={6} md={6}>
                                    <CustomTypography bold customColor={customColor?.contents_text_color}>
                                        {intl.formatMessage({ id: 'lastName' })}
                                    </CustomTypography>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        defaultValue={params.firstName}
                                        onChange={(valueInput) => handleSetParams('firstName', valueInput)}
                                        error={!!validateResults.first_name}
                                        helperText={validateResults.first_name
                                            ? intl.formatMessage(
                                                { id: validateResults.first_name.message },
                                                { maxLength: 255 },
                                            ) : ''}
                                    />
                                </GridItem>
                                <GridItem xs={6} md={6}>
                                    <CustomTypography bold customColor={customColor?.contents_text_color}>
                                        {intl.formatMessage({ id: 'firstName' })}
                                    </CustomTypography>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        defaultValue={params.lastName}
                                        onChange={(valueInput) => handleSetParams('lastName', valueInput)}
                                        error={!!validateResults.last_name}
                                        helperText={validateResults.last_name
                                            ? intl.formatMessage(
                                                { id: validateResults.last_name.message },
                                                { maxLength: 255 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.zip_code || intl.formatMessage({ id: 'zipCode' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        onChange={(valueInput) => handleInputPostalCode(valueInput)}
                                        error={!!validateResults.zip_code}
                                        helperText={validateResults.zip_code
                                            ? intl.formatMessage(
                                                { id: validateResults.zip_code.message },
                                                { maxLength: 255 },
                                            ) : ''}
                                    />
                                </GridItem>
                                <GridItem>
                                    <CustomTypography customColor={customColor?.contents_text_color}>
                                        {intl.formatMessage({ id: 'registerViewer.exampleNumber' })}
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.address || intl.formatMessage({ id: 'address' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        defaultValue={params.address}
                                        onChange={(valueInput) => handleSetParams('address', valueInput)}
                                        error={!!validateResults.address}
                                        helperText={validateResults.address
                                            ? intl.formatMessage(
                                                { id: validateResults.address.message },
                                                { maxLength: 1000 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.country_region || intl.formatMessage({ id: 'common.country' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={8}>
                                    <SelectorInput
                                        isCustomColor
                                        backgroundWhiteCustom={whiteColor}
                                        customColor={customColor?.contents_text_color}
                                        valueSelected="0"
                                        optionList={locationOption[locale]}
                                        onChange={(valueInput) => handleSetParams('location', valueInput)}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.phone_number || intl.formatMessage({ id: 'phoneNumber' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        onChange={(valueInput) => handleSetParams('phoneNumber', valueInput)}
                                        error={!!validateResults.phone_number}
                                        helperText={validateResults.phone_number
                                            ? intl.formatMessage(
                                                { id: validateResults.phone_number.message },
                                                { maxLength: 255 },
                                            ) : ''}
                                    />
                                </GridItem>
                                <GridItem>
                                    <CustomTypography customColor={customColor?.contents_text_color}>
                                        {intl.formatMessage({ id: 'registerViewer.exampleTel' })}
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.fax_number || intl.formatMessage({ id: 'exhibition.fax' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        onChange={(valueInput) => handleSetParams('faxNumber', valueInput)}
                                        error={!!validateResults.fax_number}
                                        helperText={validateResults.fax_number
                                            ? intl.formatMessage(
                                                { id: validateResults.fax_number.message },
                                                { maxLength: 255 },
                                            ) : ''}
                                    />
                                </GridItem>
                                <GridItem>
                                    <CustomTypography customColor={customColor?.contents_text_color}>
                                        {intl.formatMessage({ id: 'registerViewer.exampleTelTwo' })}
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} md={3}>
                            <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.email || intl.formatMessage({ id: 'mailAddress' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        onChange={(valueInput) => handleSetParams('email', valueInput)}
                                        error={!!validateResults.email}
                                        helperText={validateResults.email
                                            ? intl.formatMessage(
                                                { id: validateResults.email.message },
                                                { maxLength: 255 },
                                            ) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer>
                                <GridItem
                                    xs={12}
                                    md={12}
                                >
                                    <CustomTypography className={classes.paddingTop15} customColor={customColor?.contents_text_color}>
                                        {intl.formatMessage({ id: 'registerViewer.typeAgain' })}
                                    </CustomTypography>
                                    <CleanableInput
                                        classes={{ root: classes.colorTextInput }}
                                        onChange={(valueInput) => handleSetParams('emailConfirm', valueInput)}
                                        error={!!validateResults.emailConfirm}
                                        helperText={validateResults.emailConfirm
                                            ? intl.formatMessage({ id: validateResults.emailConfirm.message }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.age || intl.formatMessage({ id: 'registerViewer.age' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={8}>
                                    <SelectorInput
                                        isCustomColor
                                        backgroundWhiteCustom={whiteColor}
                                        customColor={customColor?.contents_text_color}
                                        valueSelected="0"
                                        optionList={listOptionAgeRangeFromApi}
                                        onChange={(valueInput) => handleSetParams('age_range', valueInput)}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.industry_type || intl.formatMessage({ id: 'industryType' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={8}>
                                    <SelectorInput
                                        isCustomColor
                                        backgroundWhiteCustom={whiteColor}
                                        customColor={customColor?.contents_text_color}
                                        valueSelected=""
                                        optionList={jobState}
                                        onChange={(valueInput) => handleSetParams('job', valueInput)}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.job_type || intl.formatMessage({ id: 'common.occupation' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={8}>
                                    <SelectorInput
                                        isCustomColor
                                        backgroundWhiteCustom={whiteColor}
                                        customColor={customColor?.contents_text_color}
                                        valueSelected=""
                                        optionList={occupationState}
                                        onChange={(valueInput) => handleSetParams('occupation_name', valueInput)}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.number_employees || intl.formatMessage({ id: 'common.employees' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={8}>
                                    <SelectorInput
                                        isCustomColor
                                        backgroundWhiteCustom={whiteColor}
                                        customColor={customColor?.contents_text_color}
                                        valueSelected="0"
                                        optionList={listOptionEmployeeNumberFromApi}
                                        onChange={(valueInput) => handleSetParams('employee_number', valueInput)}
                                    />

                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3}>
                            <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                {customText?.field_name?.admission_purpose || intl.formatMessage({ id: 'common.admissionPurpose' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={8}>
                                    <SelectorInput
                                        isCustomColor
                                        backgroundWhiteCustom={whiteColor}
                                        customColor={customColor?.contents_text_color}
                                        valueSelected="0"
                                        optionList={listPurposeOptionFromApi}
                                        onChange={(valueInput) => handleSetParams('purpose', valueInput)}
                                        error={!!validateResults.purpose}
                                        helperText={validateResults.purpose
                                            ? intl.formatMessage({ id: validateResults.purpose.message }) : ''}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>

                    {hasAdditionalPurpose && (
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} sm={4} md={3}>
                                <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                    {intl.formatMessage({ id: 'registerViewer.other' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <CleanableInput
                                            classes={{ root: classes.colorTextInput }}
                                            onChange={(valueInput) => handleSetParams('additional_purpose', valueInput)}
                                            error={!!validateResults.additional_purpose}
                                            helperText={validateResults.additional_purpose
                                                ? intl.formatMessage(
                                                    { id: validateResults.additional_purpose.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    )}
                    {Number(params.seminar) === 2 && registrations?.has_seminar && !registrations.free_seminar
                        && (
                            <GridContainer className={classes.spacing}>
                                <GridItem xs={12} sm={4} md={3}>
                                    <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                        {customText?.field_name?.purpose_seminar || intl.formatMessage({ id: 'registerViewer.purposeSeminar' })}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={7}>
                                    <GridContainer>
                                        <GridItem xs={12} md={8}>
                                            <SelectorInput
                                                isCustomColor
                                                backgroundWhiteCustom={whiteColor}
                                                customColor={customColor?.contents_text_color}
                                                valueSelected="0"
                                                optionList={listPurposeAnotherOptionFromApi}
                                                onChange={(valueInput) => handleSetParams('purpose_another', valueInput)}
                                                error={!!validateResults.purpose_another}
                                                helperText={validateResults.purpose_another
                                                    ? intl.formatMessage({ id: validateResults.purpose_another.message }) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        )}
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={4} md={3} />
                        <GridItem xs={12} md={7}>
                            <GridContainer>
                                <GridItem xs={12} md={12}>
                                    <CustomTypography bold customColor={customColor?.contents_text_color}>
                                        <a href="https://www.jmbxpand.com/jmb/about_XPAND/termsOfSservice/for_Visitor.html" rel="noreferrer" target="_blank">
                                            {intl.formatMessage({ id: 'registerViewer.termService' })}
                                        </a>
                                    </CustomTypography>
                                </GridItem>
                                <GridItem>
                                    <FormControlLabel
                                        control={(
                                            <Checkbox
                                                checked={params.checkRule}
                                                color="primary"
                                                style={{ color: customColor?.button_background_color?.common_button }}
                                            />
                                        )}
                                        label={<CustomTypography customColor="#4b4b4b">{intl.formatMessage({ id: 'registerViewer.accept' })}</CustomTypography>}
                                        onChange={(e) => handleSetParams('checkRule', e.target.checked)}
                                    />
                                    <FormHelperText error className="MuiFormHelperText-contained">
                                        {validateResults.checkRule
                                            ? intl.formatMessage({ id: validateResults.checkRule.message }) : ''}
                                    </FormHelperText>
                                </GridItem>
                            </GridContainer>

                        </GridItem>
                    </GridContainer>
                    <GridContainer
                        direction="row"
                        justify="center"
                        alignItems="center"
                    >
                        <Button
                            color="info"
                            gradient
                            onClick={handleSubmit}
                            round
                            className={classes.buttonBig}
                            buttonTextColor={customColor?.button_text_color}
                            buttonBackgroundColor={customColor?.button_background_color?.viewer}
                        >
                            {registrations?.settings_texts_event_viewer?.button_name?.send || intl.formatMessage({ id: 'saveCard' })}
                        </Button>
                    </GridContainer>
                </GridItem>
            </WrapperContainer>
            <Popper
                size="300px"
                isArrow
                isOpen={openPopper}
                placement={matches ? 'bottom' : 'right-start'}
                target={popperTarget}
                handleClose={() => setOpenPopper(false)}
            >
                <Box>
                    <CustomTypography bold className={classes.note} customColor={customColor?.contents_text_color}>
                        {intl.formatMessage({ id: 'registerViewer.benefitRegistration' })}
                    </CustomTypography>
                    <Box paddingTop={1} paddingBottom={1}>
                        <GridContainer>
                            <GridItem xs={2} md={2} className={classes.number}>
                                <span>
                                    1
                                </span>
                            </GridItem>
                            <GridItem xs={10} md={10} className={classes.noteContent}>
                                {intl.formatMessage({ id: 'registerViewer.textNote' }, {
                                    textExhibit: eventInfo.settings_texts_sidebar_viewer?.field_name?.exhibitor_info_list || intl.formatMessage({ id: 'home.exhibition' }),
                                    textSeminar: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list || intl.formatMessage({ id: 'home.seminar' }).toLocaleLowerCase(),
                                    textLivestream: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming || intl.formatMessage({ id: 'userRouters.liveStream' }),
                                })}
                            </GridItem>
                        </GridContainer>
                    </Box>
                    <Box paddingTop={1} paddingBottom={1}>
                        <GridContainer>
                            <GridItem xs={2} md={2} className={classes.number}>
                                <span>
                                    2
                                </span>
                            </GridItem>
                            <GridItem xs={10} md={10} className={classes.noteContent}>
                                {intl.formatMessage({ id: 'registerViewer.searchExhibition' })}
                            </GridItem>
                        </GridContainer>
                    </Box>
                    <Box paddingTop={1} paddingBottom={1}>
                        <GridContainer>
                            <GridItem xs={2} md={2} className={classes.number}>
                                <span>
                                    3
                                </span>
                            </GridItem>
                            <GridItem xs={10} md={10} className={classes.noteContent}>
                                {intl.formatMessage({ id: 'registerViewer.material' })}
                            </GridItem>
                        </GridContainer>
                    </Box>
                    <Box paddingTop={1} paddingBottom={1}>
                        <GridContainer>
                            <GridItem xs={2} md={2} className={classes.number}>
                                <span>
                                    4
                                </span>
                            </GridItem>
                            <GridItem xs={10} md={10} className={classes.noteContent}>
                                {intl.formatMessage({ id: 'registerViewer.contactPersonCharge' })}
                                <br />
                                {intl.formatMessage({ id: 'registerViewer.noteSuggestRegisterViewer' }, {
                                    email: intl.formatMessage({ id: customText?.field_name?.email || 'mailAddress' }),
                                })}
                            </GridItem>
                        </GridContainer>
                    </Box>
                </Box>
            </Popper>
            <SuccessDialog
                title={<CustomTypography bold customColor={customColor?.contents_text_color}>{intl.formatMessage({ id: 'registerViewer.applicationCompleted' })}</CustomTypography>}
                open={isOpenDialog}
                contents={(
                    <CustomTypography customColor={customColor?.contents_text_color}>
                        {intl.formatMessage({ id: 'registerViewer.suggestRegisterViewer' })}
                    </CustomTypography>
                )}
                customColor={customColor}
                handleClose={handleCloseDialog}
            />
            <SnackBar
                open={errorCreate.isOpen}
                onClose={() => setErrorCreate(false)}
                message={errorCreate.message}
                severity={errorCreate.type}
                autoHideDuration={3000}
            />
            <Loader isLoading={isLoading} />
        </>
    );
}

RegistrationViewer.defaultProps = {
    createViewer: () => { },
    registrations: {},
    errors: {},
    options: {},
    successCreate: false,
    fetchJobs: () => { },
    jobs: [],
    logOut: () => {},
    isAuthorized: false,
    customColor: {},
    getCustomText: () => {},
    customText: {},
    clearCustomText: () => {},
    getOccupations: () => {},
    occupations: {},
    clearOccupations: {},
    locale: 'ja',
    eventInfo: {},
};

RegistrationViewer.propTypes = {
    createViewer: PropTypes.func,
    registrations: PropTypes.oneOfType([() => null, PropTypes.object]),
    errors: PropTypes.oneOfType([() => null, PropTypes.object]),
    options: PropTypes.oneOfType([() => null, PropTypes.object]),
    successCreate: PropTypes.bool,
    isLoading: PropTypes.bool.isRequired,
    clearData: PropTypes.func.isRequired,
    fetchJobs: PropTypes.func,
    jobs: PropTypes.oneOfType([() => null, PropTypes.array]),
    logOut: PropTypes.func,
    isAuthorized: PropTypes.bool,
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    getCustomText: PropTypes.func,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearCustomText: PropTypes.func,
    getOccupations: PropTypes.func,
    occupations: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearOccupations: PropTypes.func,
    locale: PropTypes.string,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};
